import { VIEWING_FORM_SERIES_WARNING_LIMIT } from '../RentalPortalViewingFormModal.constants'

export function getHasViewingFormSeriesWarning(seriesCount) {
  return seriesCount > VIEWING_FORM_SERIES_WARNING_LIMIT
}
